import { FC } from "react";

type Props = {
	children: React.ReactNode;
};

export const Text: FC<Props> = ({ children }) => {
	//@ts-ignore
	const hasDash = children[0].props.text.startsWith("-");
	//@ts-ignore
	const hasDashPrettyText = hasDash && children[0].props.text.substring(1);
	if (hasDash) {
		return (
			<div className='flex'>
				<p
					className={`text-[35px] max-desktop:text-[20px] pr-[10px] mb-[22px] font-[300] pl-[30px] max-desktop:pl-[19px] max-desktop:mb-[5px] whitespace-pre-line leading-[35px] max-desktop:leading-[23px]  text-justify tracking-[0.5px]`}>
					-
				</p>
				<p
					className={`text-[35px] max-desktop:text-[20px] mb-[22px] font-[300]   max-desktop:mb-[5px] whitespace-pre-line leading-[35px] max-desktop:leading-[23px]  text-justify tracking-[0.5px]`}>
					{hasDashPrettyText}
				</p>
			</div>
		);
	} else {
		return (
			<p
				className={`text-[35px] max-desktop:text-[20px] mb-[22px] font-[300] max-desktop:mb-[5px] whitespace-pre-line leading-[35px] max-desktop:leading-[23px]  text-justify tracking-[0.5px]`}>
				{children}
			</p>
		);
	}
};

export const TextMedium: FC<Props> = ({ children }) => {
	//@ts-ignore
	const match = children[0].props.text.match(/^(\d+(\.\d+)?)\s+(.*)$/);
	const number = match ? match[1] : "";
	const text = match ? match[3] : children;
	return (
		<p className='text-[35px] max-desktop:text-[20px] leading-[38px] max-desktop:leading-[22px] text-left font-[300] pt-[65px] pb-[31px] max-desktop:pt-[45px] max-desktop:pb-[20px] whitespace-pre-line tracking-[0.4px]'>
			<span className='mr-[40px] max-desktop:mr-[20px]'>{number}</span>
			<span>{text}</span>
		</p>
	);
};

export const TextBig: FC<Props> = ({ children }) => {
	//@ts-ignore
	const match = children[0].props.text.match(/^(\d+(\.\d+)?)\s+(.*)$/);
	const number = match ? match[1] : "";
	const text = match ? match[3] : children;
	return (
		<p className='text-[50px] max-desktop:text-[38px] font-[600] text-left pt-[100px] pb-[65px] max-desktop:pt-[59px] max-desktop:pb-[45px] whitespace-pre-line  tracking-[1px] leading-[55px] max-desktop:leading-[40px]'>
			<span className='mr-[70px] max-desktop:mr-[30px]'>{number}</span>
			<span>{text}</span>
		</p>
	);
};
